<template>
  <div>
    <table>
      <tr>
        <th>Field</th>
        <th>Value</th>
      </tr>
      <tr>
        <td>Name</td>
        <td>{{ getProperty(["name"]) }}</td>
      </tr>
      <tr>
        <td>Description</td>
        <td>{{ getProperty(["description"]) }}</td>
      </tr>
      <tr>
        <td>URL</td>
        <td>{{ getProperty(["url"]) }}</td>
      </tr>
      <tr>
        <td>Year Founded</td>
        <td>{{ getProperty(["year_founded"]) }}</td>
      </tr>
      <tr>
        <td>Logo</td>
        <td><img :src="getProperty(['logo'])" /></td>
      </tr>
      <tr>
        <td>Cover Photo</td>
        <td><img :src="getProperty(['cover_photo'])" /></td>
      </tr>
      <tr>
        <td>Last Updated</td>
        <td>{{ getProperty(["updated_at"]) }}</td>
      </tr>
    </table>

    <hr />

    <h4>Provider Countries</h4>

    <table>
      <tr>
        <th>countries</th>
        <th>Last Updated</th>
      </tr>
      <tr
        v-for="country in getProperty(['provider_countries'])"
        v-if="country.country"
      >
        <td>{{ country.country.name }}</td>
        <td>{{ country.updated_at }}</td>
      </tr>
    </table>

    <hr />

    <h4>Provider Sectors</h4>

    <table>
      <tr>
        <th>Sectors</th>
        <th>Relevancy</th>
        <th>Last Updated</th>
      </tr>
      <tr
        v-for="sector in getProperty(['provider_sectors'])"
        v-if="sector.sector"
      >
        <td>{{ sector.sector.name }}</td>
        <td>{{ sector.relevancy }}</td>
        <td>{{ sector.updated_at }}</td>
      </tr>
    </table>

    <hr />

    <h4>Provider Capital Types</h4>

    <table>
      <tr>
        <th>Name</th>
        <th>Last Updated</th>
      </tr>
      <tr
        v-for="capitalType in getProperty(['provider_capital_types'])"
        v-if="capitalType.capital_type"
      >
        <td>{{ capitalType.capital_type.name }}</td>
        <td>{{ capitalType.updated_at }}</td>
      </tr>
    </table>

    <hr />

    <h4>Provider Provider Types</h4>

    <table>
      <tr>
        <th>Name</th>
        <th>Last Updated</th>
      </tr>
      <tr
        v-for="providerType in getProperty(['provider_provider_types'])"
        v-if="providerType.provider_type"
      >
        <td>{{ providerType.provider_type.name }}</td>
        <td>{{ providerType.updated_at }}</td>
      </tr>
    </table>

    <hr />

    <h4>Provider Languages</h4>

    <table>
      <tr>
        <th>Name</th>
        <th>Last Updated</th>
      </tr>
      <tr
        v-for="languages in getProperty(['provider_languages'])"
        v-if="languages.language"
      >
        <td>{{ languages.language.name }}</td>
        <td>{{ languages.updated_at }}</td>
      </tr>
    </table>

    <hr />

    <h4>Provider Currencies</h4>

    <table>
      <tr>
        <th>Name</th>
        <th>Last updated</th>
      </tr>
      <tr
        v-for="providerCurrency in getProperty(['provider_currencies'])"
        v-if="providerCurrency.currency"
      >
        <td>{{ providerCurrency.currency.name }}</td>
        <td>{{ providerCurrency.updated_at }}</td>
      </tr>
    </table>

    <hr />

    <h4>Provider Social Media</h4>

    <table>
      <tr>
        <th>Name</th>
        <th>Url</th>
        <th>Last updated</th>
      </tr>
      <tr
        v-for="providerSocialMedia in getProperty(['provider_social_medias'])"
        v-if="providerSocialMedia.social_media"
      >
        <td>{{ providerSocialMedia.social_media.name }}</td>
        <td>{{ providerSocialMedia.url }}</td>
        <td>{{ providerSocialMedia.updated_at }}</td>
      </tr>
    </table>

    <hr />

    <h4>Provider Stats</h4>

    <table>
      <tr>
        <th>Name</th>
        <th>Value</th>
        <th>Last updated</th>
      </tr>
      <tr
        v-for="providerStat in getProperty(['provider_stats'])"
        v-if="providerStat.stat"
      >
        <td>{{ providerStat.stat.name }}</td>
        <td
          v-if="
            providerStat.stat && providerStat.stat.code == 'board_seat_binary'
          "
        >
          {{ providerStat.value == 1 ? "yes" : "no" }}
        </td>
        <td v-else>
          {{ providerStat.value }}
        </td>
        <td>{{ providerStat.updated_at }}</td>
      </tr>
    </table>

    <hr />

    <h4>Provider Descriptions</h4>

    <table>
      <tr>
        <th>Name</th>
        <th>Value</th>
        <th>Last updated</th>
      </tr>
      <tr
        v-for="providerDesc in getProperty(['provider_descriptions'])"
        v-if="providerDesc.description"
      >
        <td>{{ providerDesc.description.name }}</td>
        <td>{{ providerDesc.value }}</td>
        <td>{{ providerDesc.updated_at }}</td>
      </tr>
    </table>

    <div v-for="(contact, index) in getProperty(['contacts'])">
      <hr />

      <h4>Contact {{ index + 1 }}</h4>

      <table>
        <tr>
          <th>Last updated</th>
          <td>{{ contact.updated_at }}</td>
        </tr>
        <tr>
          <th>Title</th>
          <td>{{ contact.title }}</td>
        </tr>
        <tr>
          <th>Name</th>
          <td>{{ contact.name }}</td>
        </tr>
        <tr>
          <th>Email</th>
          <td>{{ contact.email }}</td>
        </tr>
        <tr>
          <th>Phone Number</th>
          <td>{{ contact.phone_number }}</td>
        </tr>
      </table>
    </div>

    <div v-for="(office, index) in getProperty(['offices'])">
      <hr />

      <h4>Office {{ index + 1 }}</h4>

      <table>
        <tr>
          <th>Last updated</th>
          <td>{{ office.updated_at }}</td>
        </tr>

        <tr>
          <th>address_line_1</th>
          <td>{{ office.address_line_1 }}</td>
        </tr>
        <tr>
          <th>address_line_2</th>
          <td>{{ office.address_line_2 }}</td>
        </tr>
        <tr>
          <th>address_line_3</th>
          <td>{{ office.address_line_3 }}</td>
        </tr>
        <tr>
          <th>city</th>
          <td>{{ office.city }}</td>
        </tr>
        <tr>
          <th>zip_code</th>
          <td>{{ office.zip_code }}</td>
        </tr>
        <tr>
          <th>coordinates</th>
          <td>{{ office.coordinates }}</td>
        </tr>
        <tr>
          <th>country</th>
          <td>
            <span v-if="office.country">
              {{ office.country.name }}
            </span>
          </td>
        </tr>
      </table>
    </div>

    <div v-for="(deal, index) in getProperty(['relationships'])">
      <hr />

      <h4>Deal {{ index + 1 }}</h4>

      <table>
        <tr>
          <th>Amount</th>
          <th>Year</th>
          <th>Source</th>
        </tr>

        <tr>
          <td>{{ deal.jdoc.amount }}</td>
          <td>{{ deal.jdoc.year }}</td>
          <td>{{ deal.jdoc.source }}</td>
        </tr>
      </table>

      <br />

      <table>
        <tr>
          <th>Investors</th>
          <th>Investees</th>
        </tr>
        <td>
          <p v-for="investor in deal.jdoc.investors">
            {{ getInvestorById(investor) }}
          </p>
        </td>
        <td>
          <p v-for="investee in deal.jdoc.investees">
            {{ getInvesteeById(investee) }}
          </p>
        </td>
        <tr></tr>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "display-element",
  computed: {
    ...mapGetters({
      getProperty: "getEditedProviderValueByKeyChain",
      companies: "companies",
      providers: "providerList"
    })
  },
  methods: {
    getInvestorById(id) {
      return this.providers.find(item => item.id == id).name;
    },
    getInvesteeById(id) {
      return this.companies.find(item => item.id == id).name;
    }
  }
};
</script>

<style scoped>
table {
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #eaeaea;
}
</style>



// WEBPACK FOOTER //
// src/elements/display.vue